export class Currencies {
  static getCurrencies() {
    return [
      {
        id: 1,
        name: 'Euro',
        symbol: '€',
        isDefault: true,
      },
      {
        id: 2,
        name: 'USD',
        symbol: '$',
        isDefault: false,
      },
      {
        id: 3,
        name: 'GBP',
        symbol: '£',
        isDefault: false,
      },
    ];
  }

  static formatPrice(price : number, currencyID : number): string {

    const currencies = Currencies.getCurrencies();

    if (currencyID === undefined || currencyID === 0) {
      // Assume it's in the default currency.
      // Find what it is
      const defaultCurrency = currencies.find((currency) => currency.isDefault);

      if (defaultCurrency) {
        // eslint-disable-next-line no-param-reassign
        currencyID = defaultCurrency.id;
      }
    }

    // Find the currency
    const modelCurrencyInfo = currencies.find(
      (currency) => Number(currency.id) === Number(currencyID),
    );

    if (modelCurrencyInfo === undefined) {
      return '';
    }

    return `${Intl.NumberFormat().format(price)}${modelCurrencyInfo.symbol}`;
  }
  static getSymbol(currencyID : number): string {

    const currencies = Currencies.getCurrencies();

    if (currencyID === undefined || currencyID === 0) {
      // Assume it's in the default currency.
      // Find what it is
      const defaultCurrency = currencies.find((currency) => currency.isDefault);

      if (defaultCurrency) {
        // eslint-disable-next-line no-param-reassign
        currencyID = defaultCurrency.id;
      }
    }

    // Find the currency
    const modelCurrencyInfo = currencies.find(
      (currency) => Number(currency.id) === Number(currencyID),
    );

    if (modelCurrencyInfo === undefined) {
      return '';
    }

    return `${modelCurrencyInfo.symbol}`;
  }
}
